﻿require('./../scss/style.scss');

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./vendor/', true, /\.js$/));
requireAll(require.context('./project/', true, /\.js$/));
